module['exports'] = [
  'منایل',
  'عایشہ',
  'آمنہ',
  'عمائم',
  'خدیجہ',
  'حفصہ',
  'رابعہ',
  'اقدس',
  'حسنہ',
  'مریم',
  'حمیرہ',
  'وردہ',
  'شہناز',
  'نوشین',
  'مشال',
  'روبینہ',
  'روزینہ',
  'حدید',
];
